<!--
Author: TangChen
Date: 2018-09-17
Desc: 菜单组件，由index.js 配置引入
-->
<template>
    <div class="comp-menu comp">
        <el-menu
            ref="menu"
            :default-active="menuCheck"
            class="el-menu-out"
            mode="horizontal"
            :unique-opened="true"
            v-on:select="handleMenuSelect"
        >
            <el-row v-if="load" class="comp-menu-list">
                <el-col v-for="item of menus" :key="item.i" :span="4">
                    <el-submenu
                        v-if="item.menu"
                        :index="item.i"
                        :class="getTopMenuClass(item)"
                        popper-class="comp-menu-popup"
                    >
                        <template slot="title">
                            <!-- <i :class="item.icon"  aria-hidden="true" ></i> -->
                            <!-- <icon-combo :data="icon" :iconCla="item.icon"></icon-combo> -->
                            <span>{{ item.name }}</span>
                        </template>
                        <template v-if="item.menu">
                            <template v-for="items in item.menu">
                                <el-menu-item
                                    v-if="
                                        (info.isCC === '1' || items.link !== '/profitqry') &&
                                        (info.isCC === '1' || items.link !== '/service') &&
                                        (info.isCC === '1' || items.link !== '/statement') &&
                                        (info.isetf === '1' || items.link !== '/etflist')
                                    "
                                    :key="items.name"
                                    :index="items.link"
                                >
                                    {{ items.name }}
                                </el-menu-item>
                            </template>
                        </template>
                    </el-submenu>
                    <el-menu-item
                        v-else
                        :index="item.link"
                        class="grouped"
                        :class="getTopMenuClass(item)"
                    >
                        <!-- <icon-combo :data="icon" :iconCla="item.icon"></icon-combo> -->
                        <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                </el-col>
            </el-row>
        </el-menu>
    </div>
</template>
<script>
import fundApi from "@/api/fund";

export default {
    name: "NavMenu",
    props: {
        active: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            menus: [
                {
                    icon: "fa fa-home",
                    name: "我的账户",
                    i: "1",
                    menuid: 100,
                    menu: [
                        { name: "我的账户", link: "/home", menuid: 100001 },
                        { name: "快速交易", link: "/quickTrade", menuid: 100002 },
                        { name: "交易记录", link: "/traderecord", menuid: 100003 },
                        { name: "我的定投", link: "/myplan", menuid: 100004 },
                        { name: "分红管理", link: "/dividendInfo", menuid: 100005 },
                        { name: "账户管理", link: "/acctManager", menuid: 100006 }
                    ]
                },
                // {
                //     icon: "fa fa-jpy",
                //     name: "现金宝",
                //     i: "2",
                //     link: "/currencyfund"
                // },
                {
                    icon: "fa fa-jpy",
                    name: this.$const.getXJBParam("name"),
                    i: "2",
                    link: "/moneyBox",
                    menuid: 101
                },
                {
                    icon: "fa fa-shopping-cart",
                    name: "基金超市",
                    i: "3",
                    link: "/fund",
                    menuid: 102
                },
                {
                    icon: "fa fa-chart-line",
                    name: "基金定投",
                    i: "4",
                    link: "/gfund/glist",
                    menuid: 104
                }
                // {
                //     icon: "fa fa-gem",
                //     name: "养老专区",
                //     i: "5",
                //     link: ""
                // }
                // {
                //     icon: "fa fa-gem",
                //     name: "专户理财",
                //     i: "5",
                //     menu: [
                //         { name: "专户理财产品", link: "/privatefund" },
                //         { name: "我的专户理财", link: "/private" },
                //         { name: "信息披露", link: "/infoPublish" }
                //     ]
                // },
                // {
                //     icon: "fa fa-user",
                //     name: "个人中心",
                //     i: "6",
                //     menu: [
                //         { name: "信息中心", link: "/info" },
                //         { name: "我的银行卡", link: "/bank" },
                //         { name: "风险测评", link: "/risk" },
                //         { name: "安全中心", link: "/securitycenter" },
                //         // { name: "服务定制", link: "/service" },
                //         // { name: "对账单信息", link: "/statement" },
                //         { name: "投资者信息收集", link: "/infoCollection" },
                //         { name: "投资者转换", link: "/invchange" },
                //         { name: "个人税收居民类型声明", link: "/info/taxeslist" },
                //         { name: "政策法规", link: "/policyAndLaw" }
                //     ]
                // }
            ],
            icon: {
                w: "24"
            },
            menuCheck: "/home",
            info: {},
            load: true,
            checkassetsisyes: false // 是否仅根据专户持仓份额判断
        };
    },
    watch: {
        "$route.path": {
            immediate: true,
            handler(val) {
                this.resetMenuActive(val);
            }
        }
    },
    mounted() {
        const menuModule =
            (this.$cache.getParamValue("menu_module") &&
                this.$cache.getParamValue("menu_module").menus) ||
            [];
        const accreditedinvestorlimitList = [];
        const getValidMenuIds = (menuModule) => {
            const ids = new Set();
            const traverse = (items) => {
                items.forEach((item) => {
                    ids.add(item.menuid);
                    if (
                        !this.$util.isEmpty(item.accreditedinvestorlimit) &&
                        item.accreditedinvestorlimit
                    ) {
                        accreditedinvestorlimitList.push(item.menuid);
                        if (!this.$util.isEmpty(item.checkassetsisyes) && item.checkassetsisyes) {
                            this.checkassetsisyes = true;
                        }
                    }
                    if (item.menu) traverse(item.menu);
                });
            };
            traverse(menuModule);
            return Array.from(ids);
        };
        const validMenuIds = getValidMenuIds(menuModule);

        if (!this.$util.xjbIsOpen()) {
            this.menus = this.menus.filter((item) => {
                return item.i !== "2";
            });
        }

        // 模块化参数需要显示高端理财才显示
        if (
            this.$cache.getParamValue("special_moudule") &&
            this.$cache.getParamValue("special_moudule").special_moudule_enable
        ) {
            this.menus.push({
                icon: "fa fa-financial-management",
                name: "高端理财",
                i: "5",
                menu: [
                    { name: "资产总览", link: "/financial/Management" }
                    // { name: "产品列表", link: "/fundManagement/list" }
                ]
            });
        }

        const userInfo = this.$cache.getUser();
        const isProfessionalUser =
            !this.$util.isEmpty(userInfo.accreditedinvestor) && userInfo.accreditedinvestor !== "0";
        const filterMenus = (menus, validIds) => {
            const flag = sessionStorage.getItem("_showSpecial") == "1";
            return menus.filter((menu) => {
                if (!menu.menu) return validIds.includes(menu.menuid);

                const filteredSubMenu = menu.menu.filter((subMenu) =>
                    validIds.includes(subMenu.menuid)
                );
                if (filteredSubMenu.length === 0) return false;

                let isShow = true;
                if (accreditedinvestorlimitList.includes(menu.menuid)) {
                    isShow = this.checkassetsisyes ? flag : isProfessionalUser || flag;
                }
                if (isShow) {
                    Object.assign(menu, { menu: filteredSubMenu });
                    return true;
                }
                return false;
            });
        };

        if (validMenuIds.length > 0) {
            const flag = sessionStorage.getItem("_showSpecial");
            if (
                !flag &&
                accreditedinvestorlimitList.length &&
                (this.checkassetsisyes || !isProfessionalUser)
            ) {
                this.load = false;
                fundApi
                    .qrySpecialAsset({
                        producttype: "@",
                        keyword: "",
                        pageSize: 20,
                        pageNum: 1,
                        assetshowtype: 0,
                        specialassetflag: "1"
                    })
                    .then((res) => {
                        this.load = true;
                        // 高端理财菜单默认不展示，需要判断配置了菜单参数后控制
                        this.menus.push({
                            icon: "fa fa-financial-management",
                            name: this.$util.getMenuName(105, "高端理财"),
                            i: "5",
                            menuid: 105,
                            menu: [
                                {
                                    name: this.$util.getMenuName(105001, "资产总览"),
                                    link: "/financial/Management",
                                    menuid: 105001
                                },
                                {
                                    name: this.$util.getMenuName(105002, "专户公告"),
                                    link: "/financial/notice",
                                    menuid: 105002
                                },
                                {
                                    name: this.$util.getMenuName(105003, "产品净值"),
                                    link: "/financial/fundnav",
                                    menuid: 105003
                                }
                            ]
                        });
                        const showFlag =
                            res.data && res.data.first && res.data.first.specialasset > 0;
                        sessionStorage.setItem("_showSpecial", showFlag ? "1" : "0");
                        this.menus = filterMenus(this.menus, validMenuIds);
                        // 获取当前选中菜单
                        const _x = this.$route.path;
                        // 菜单自动选中
                        this.resetMenuActive(_x);
                    })
                    .catch(() => {
                        this.load = true;
                        this.menus = filterMenus(this.menus, validMenuIds);
                        // 获取当前选中菜单
                        const _x = this.$route.path;
                        // 菜单自动选中
                        this.resetMenuActive(_x);
                    });
                return;
            }
            // 高端理财菜单默认不展示，需要判断配置了菜单参数后控制
            this.menus.push({
                icon: "fa fa-financial-management",
                name: this.$util.getMenuName(105, "高端理财"),
                i: "5",
                menuid: 105,
                menu: [
                    {
                        name: this.$util.getMenuName(105001, "资产总览"),
                        link: "/financial/Management",
                        menuid: 105001
                    },
                    {
                        name: this.$util.getMenuName(105002, "专户公告"),
                        link: "/financial/notice",
                        menuid: 105002
                    },
                    {
                        name: this.$util.getMenuName(105003, "产品净值"),
                        link: "/financial/fundnav",
                        menuid: 105003
                    }
                ]
            });

            this.menus = filterMenus(this.menus, validMenuIds);
        }

        this.info = this.$cache.getUser();
        // 获取当前选中菜单
        const _x = this.$route.path;
        // 菜单自动选中
        this.resetMenuActive(_x);
    },
    methods: {
        getMenuActive(path) {
            const currentPath = (path || "/home").toLowerCase();
            if (currentPath === "/moneybox" || currentPath.indexOf("/moneybox/") === 0) {
                return "/moneyBox";
            }
            if (currentPath === "/autoaccess" || currentPath.indexOf("/autoaccess/") === 0) {
                return "/moneyBox";
            }
            if (currentPath === "/fund" || currentPath.indexOf("/fund/") === 0) {
                return "/fund";
            }
            if (currentPath === "/gfund" || currentPath.indexOf("/gfund/") === 0) {
                return "/gfund/glist";
            }
            if (
                currentPath === "/financial/management" ||
                currentPath.indexOf("/financial/") === 0
            ) {
                return "/financial/Management";
            }
            return path || "/home";
        },
        resetMenuActive(path) {
            const activePath = this.getMenuActive(path);
            this.menuCheck = activePath;
        },
        isTopMenuActive(item) {
            if (!item) {
                return false;
            }
            const currentActive = this.getMenuActive(this.$route.path).toLowerCase();
            if (item.menu && item.menu.length) {
                return item.menu.some((menuItem) => {
                    return this.getMenuActive(menuItem.link).toLowerCase() === currentActive;
                });
            }
            return this.getMenuActive(item.link).toLowerCase() === currentActive;
        },
        getTopMenuClass(item) {
            return this.isTopMenuActive(item) ? "manual-active" : "manual-inactive";
        },
        handleMenuSelect(index) {
            if (!index) {
                return;
            }
            const currentActive = this.getMenuActive(this.$route.path).toLowerCase();
            if (index.toLowerCase() === currentActive) {
                this.resetMenuActive(this.$route.path);
                return;
            }
            this.$router
                .push(index)
                .catch(() => {})
                .finally(() => {
                    // 只按真实停留的路由恢复栏目高亮，避免拦截失败后残留理财宝选中态
                    this.resetMenuActive(this.$route.path);
                });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-menu {
    outline: none !important;
    .comp-menu-list {
        display: flex;
        justify-content: flex-end;
    }
    .el-menu.el-menu-out {
        outline: none !important;
        border: none;
        width: 950px;
        margin: 0 auto;
        background: inherit;
        .el-row {
            outline: none;
        }
        .el-menu-item.grouped,
        .el-submenu .el-submenu__title {
            height: auto;
            font-weight: 500;
            font-size: $f20;
            // margin: 0 10px;
            color: $text-color2;
            line-height: 52px;
            width: 140px;
            height: 52px;
            border-radius: 4px;
            display: flex;
            i {
                color: inherit;
                display: inline-block;
                text-align: center;
            }
            span {
                display: inline-block;
                line-height: 52px;
            }
            &:hover {
                background: #ffecec;
                border-color: $color-a-m;
                color: $bg18;
                i {
                    color: $bg18 !important;
                }
            }
        }
        .el-menu-item.grouped span {
            width: 140px;
        }
        .el-menu-item.grouped.manual-active,
        .el-submenu.manual-active .el-submenu__title {
            border-color: $color-a-m;
            color: $bg18;
            background: #ffecec;
            i {
                color: $bg18 !important;
            }
        }
        .el-menu-item.grouped.is-active.manual-inactive,
        .el-submenu.is-active.manual-inactive .el-submenu__title {
            border-color: transparent;
            color: $text-color2;
            background: inherit;
            i {
                color: inherit !important;
            }
        }
        .el-menu-item.is-active,
        .el-submenu.is-active .el-submenu__title {
            border-color: $color-a-m;
            color: $bg18;
            background: #ffecec;
            i {
                color: $bg18 !important;
            }
        }
    }
    .el-icon-arrow-down:before {
        content: "\E790" !important;
    }
    .el-submenu__icon-arrow {
        font-size: 16px !important;
    }
    .el-submenu__title i {
        color: #333 !important;
    }
}
li.el-menu-item.grouped {
    text-align: center;
}
.el-menu--horizontal.comp-menu-popup .el-menu.el-menu--popup.el-menu--popup-bottom-start {
    text-align: center;
    left: -12px;
    top: 9.2px;
    padding: 18px 0;
    min-width: 170px;
    font-size: $f16;
}
.el-menu--horizontal.comp-menu-popup .el-menu--popup {
    border-radius: 2px 20px 2px 20px !important;
}
</style>
